import '@availity/yup';
import * as yup from 'yup';

const formValidation = yup.object().shape({
  slug: yup.string(),
  target: yup.string().required(),
  description: yup.string(),
});

export default formValidation;
